import axios from "../axiosApi";

const enrichDisciplineOfferLevels = async (offers: any[]) => {
    const disciplineIds = Array.from(new Set(
        offers
            .map((offer: any) => offer?.disciplineModule?.discipline?.id)
            .filter(Boolean)
    ));

    if (disciplineIds.length === 0) return offers;

    const disciplineFilter = JSON.stringify({
        where: { id: { inq: disciplineIds } },
        include: ["level"],
    });
    const response = await axios.get(`/Disciplines?filter=${encodeURIComponent(disciplineFilter)}`);
    const disciplinesById = new Map(
        (response.data || []).map((discipline: any) => [discipline.id, discipline])
    );

    offers.forEach((offer: any) => {
        const discipline = offer?.disciplineModule?.discipline;
        if (discipline?.id && disciplinesById.has(discipline.id)) {
            const disciplineWithLevel: any = disciplinesById.get(discipline.id);
            offer.disciplineModule.discipline = {
                ...discipline,
                ...disciplineWithLevel,
            };
        }
    });

    return offers;
};

/**
 * Fetches all Levels with schoolAuthorization include.
 * Returns the data array directly (no Redux dispatch — used locally in components).
 */
export const fetchLevels = () => {
    return async (dispatch: any) => {
        try {
            const filter = JSON.stringify({
                include: ["schoolAuthorization"],
                order: "Description",
            });
            const response = await axios.get(`/Levels?filter=${encodeURIComponent(filter)}`);
            return response.data || [];
        } catch (e) {
            console.error("fetchLevels ERROR", e);
            return [];
        }
    };
};

export const fetchPeriods = () => {
    return async (dispatch: any) => {
        try {
            const filter = JSON.stringify({
                order: "Description DESC",
            });
            const response = await axios.get(`/Periods?filter=${encodeURIComponent(filter)}`);
            return response.data || [];
        } catch (e) {
            console.error("fetchPeriods ERROR", e);
            return [];
        }
    };
};

export const fetchSchoolAuthorizations = () => {
    return async (dispatch: any) => {
        try {
            const filter = JSON.stringify({
                order: "Description",
            });
            const response = await axios.get(`/SchoolAuthorizations?filter=${encodeURIComponent(filter)}`);
            return response.data || [];
        } catch (e) {
            console.error("fetchSchoolAuthorizations ERROR", e);
            return [];
        }
    };
};

export const fetchAtaAnualOficial = (
    schoolAuthorizationId: number,
    ano: number,
    etapa: number,
    overwriteOrder = false,
    apuracaoDate = '',
    totalDays = '',
    totalWorkload = '',
    stageWorkload = ''
) => {
    return async (dispatch: any) => {
        const params = encodeURIComponent(JSON.stringify({
            schoolAuthorizationId,
            ano,
            etapa,
            overwriteOrder,
            apuracaoDate,
            totalDays,
            totalWorkload,
            stageWorkload,
        }));
        const response = await axios.get(`/DisciplineOffers/ataAnualOficial?params=${params}`);
        return response.data || [];
    };
};

/**
 * Fetches ClassOffers, optionally filtered by Level_id.
 */
export const fetchClassOffers = (levelId?: number | '') => {
    return async (dispatch: any) => {
        try {
            const filterObj: any = {
                include: ["level"],
                order: "Description",
            };
            if (levelId) {
                filterObj.where = { Level_id: levelId };
            }
            const filter = JSON.stringify(filterObj);
            const response = await axios.get(`/ClassOffers?filter=${encodeURIComponent(filter)}`);
            return response.data || [];
        } catch (e) {
            console.error("fetchClassOffers ERROR", e);
            return [];
        }
    };
};

/**
 * Fetches DisciplineOffers, optionally filtered by ClassOffer_id.
 * Includes disciplineModule -> discipline and teacher.
 */
export const fetchDisciplineOffers = (classOfferId?: number | '') => {
    return async (dispatch: any) => {
        try {
            const filterObj: any = {
                include: [
                    { classOffer: "level" },
                    "period",
                    "teacher",
                    { disciplineModule: "discipline" },
                ],
                order: "id DESC",
            };
            if (classOfferId) {
                filterObj.where = { ClassOffer_id: classOfferId };
            }
            const filter = JSON.stringify(filterObj);
            const response = await axios.get(`/DisciplineOffers?filter=${encodeURIComponent(filter)}`);
            return await enrichDisciplineOfferLevels(response.data || []);
        } catch (e) {
            console.error("fetchDisciplineOffers ERROR", e);
            return [];
        }
    };
};

/**
 * Fetches base student list from /persons/listaAlunosBase.
 */
export const fetchStudentsBase = () => {
    return async (dispatch: any) => {
        try {
            const response = await axios.get(`/persons/listaAlunosBase`);
            return response.data || [];
        } catch (e) {
            console.error("fetchStudentsBase ERROR", e);
            return [];
        }
    };
};
